import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e0522788")

_pushScopeId("data-v-e0522788")
const _hoisted_1 = {
  key: 0,
  class: "pw-url-errors player-adon"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "error-icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      r: "14.5",
      transform: "matrix(-1 0 0 1 16 16)",
      stroke: "white",
      "stroke-width": "3"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M16 9.33325L16 17M16 21.5999L16 22.6666",
      stroke: "white",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Video could not be loaded. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.videoPlaybackError.value)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
})